import { render, staticRenderFns } from "./ModaLocalProibidoClasse.vue?vue&type=template&id=b7571fa6&scoped=true"
import script from "./ModaLocalProibidoClasse.vue?vue&type=script&lang=js"
export * from "./ModaLocalProibidoClasse.vue?vue&type=script&lang=js"
import style0 from "./ModaLocalProibidoClasse.vue?vue&type=style&index=0&id=b7571fa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7571fa6",
  null
  
)

export default component.exports